import type { DomainMapper } from '../types';

const no: DomainMapper = {
  countryCode: 'no',
  currency: 'NOK',
  domain: 'kahrs-preview.iveo.store',
  environment: 'preview',
  flagUrl: '/flags/NO.svg',
  languagePrimary: true,
  locale: 'no',
  logoUrl: 'kahrs-logo',
  noRobots: true,
  productBasePath: 'produkt',
  sitemapUrl: 'https://ecom-api.kahrs.com/storage/sitemaps/sitemap-no.xml',
  storyblokBasePath: 'no',
  url: 'https://kahrs-preview.iveo.store/no',
  algoliaIndex: 'b2b-no-nb-NO-products',
  algoliaIndexAutocomplete: 'b2b-no-nb-NO-products_query_suggestions',
  algoliaIndexPages: 'content_',
  applicationId: 1356,
  subFolder: true,
  b2b: {
    enabled: true,
    purchaseEnabled: true,
    storyblokBasePath: 'b2b',
    applicationId: 1356,
    algoliaIndex: 'b2b-no-nb-NO-products',
    algoliaIndexAutocomplete: 'b2b-no-nb-NO-products_query_suggestions',
    displayIncVat: false,
    default: true,
    productBasePath: 'b2b/produkt',
    sitemapUrl: 'https://ecom-api.kahrs.com/storage/sitemaps/sitemap-no.xml',
  },
  b2c: {
    enabled: false,
    productBasePath: 'produkt',
  },
  features: {
    fastOrder: true,
    backorders: false,
    cartSettings: true,
  },
  showNonPublicProducts: true,
} as DomainMapper;

export default no;
